module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN403_1975488458.fbf289a2.png";